import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  fetchFAQ,
  addInternationalPatientContact,
  fetchInternationalHealthcareList,
  fetchInsurancePartnerList,
  fetchInternationalGuidelines,
  fetchGuidelinesChecklistPaymentAdvisory,
  fetchInternationalPatientBanner,
  fetchPatientStoryVideos,
  fetchSpecialties,
  fetchDoctors,
  fetchInternationalStatics,
  fetchInternationalWhychooseus,
  fetchOurServicesCategoryList,
  fetchOurServicesCategoryDetails,
  fetchInternationalPatientPageSeo,
} from "../Adapter/PageAdapter";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { baseImage_path } from "../variables/Variables";
import { stripHtmlForMeta } from "../utils/seoMetaText";
// import useSeo from "../hooks/useSeo";
// import SeoHelmet from "../components/SeoHelmet";
import { Helmet } from "react-helmet-async";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { NavLink } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { Toaster, toast } from 'sonner';
import VideoTestimonials from "../components/VideoTestimonials";
import bannerImage from "../assets/images/International Patient.jpg";

import mailIcon from "../assets/images/formmailicn.svg";
import whatsappIcon from "../assets/images/wappicn.svg";
import callIcon from "../assets/images/concallicn.svg";
import BlackArrow from "../assets/images/black-arr.png";

import VectorIcon from "../assets/images/Vector.png";

import arrowIcon from "../assets/images/arrw.svg";

import oursic1 from "../assets/images/oursic1.svg";
import oursic2 from "../assets/images/oursic2.svg";
import oursic3 from "../assets/images/oursic3.svg";
import oursic4 from "../assets/images/oursic4.png";
import oursic5 from "../assets/images/oursic5.png";
import oursic6 from "../assets/images/oursic6.png";
import oursic7 from "../assets/images/oursic7.png";
import oursic8 from "../assets/images/oursic8.png";
import oursic9 from "../assets/images/oursic9.png";
import oursic10 from "../assets/images/oursic10.png";
import oursic11 from "../assets/images/oursic11.png";
import oursic12 from "../assets/images/oursic12.png";
import imagefttw from "../assets/images/inp/award/image42.png";
import imageftthre from "../assets/images/inp/award/image43.png";
import imageftfour from "../assets/images/inp/award/image44.png";
import imageftfive from "../assets/images/inp/award/image45.png";
import imageftsix from "../assets/images/inp/award/image46.png";
import imagesxsev from "../assets/images/inp/award/image67.png";
import eurpoe from "../assets/images/inp/award/eurpoe.png";
import imagesxnine from "../assets/images/inp/award/image69.png";
import imagesevothre from "../assets/images/inp/award/image703.png";
import paraheal from "../assets/images/inp/award/paraheal.png";
import imagesevtwo from "../assets/images/inp/award/image72.png";
import raksha from "../assets/images/inp/award/raksha.png";
import cigna from "../assets/images/inp/award/cigna.png";
import cmn from "../assets/images/inp/award/cmn.png";
import euro from "../assets/images/inp/award/euro.png";
import bupa from "../assets/images/inp/award/bupa.png";
import geoblu from "../assets/images/inp/award/geoblu.png";
import healthtsixty from "../assets/images/inp/award/healthtsixty.png";
import grouphener from "../assets/images/inp/award/grouphener.png";
import sos from "../assets/images/inp/award/sos.png";
import maxbupa from "../assets/images/inp/award/maxbupa.png";
import imageeghttw from "../assets/images/inp/award/image82.png";
import imageeghtthre from "../assets/images/inp/award/image83.png";
import roy from "../assets/images/inp/award/roy.png";
import frsaa from "../assets/images/inp/award/frsaa.png";

const YOUTUBE_API_KEY = "AIzaSyCqtCNhyC9MIm1YeWy7eSlR6q1X3F-RoPw";

const InternationalPatients = () => {
  const { id } = useParams();
  const [bannerData, setBannerData] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [activeTab, setActiveTab] = useState("prearrivalpill");
  const [selectedTab, setSelectedTab] = useState("checklistpill");
  const [faq, setFaq] = useState([]);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [patientStories, setPatientStories] = useState([]);

  const [healthcareData, setHealthcareData] = useState(null);
  const [insurancePartners, setInsurancePartners] = useState([]);
  const [guidelines, setGuidelines] = useState([]);

  const [checklistContent, setChecklistContent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statisticsData, setStatisticsData] = useState([]);
  const [reasonsData, setReasonsData] = useState([]);
  const [servicesData, setServicesData] = useState([]);

  const [specialitiesData, setSpecialitiesData] = useState([]);
  const [categoryDetails, setCategoryDetails] = useState([]);
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    const loadSeo = async () => {
      try {
        console.log("Calling fetchInternationalPatientPageSeo...");
        const res = await fetchInternationalPatientPageSeo();
        console.log("API Response:", res);
        if (res && res.data) {
          setSeoData(res.data);
        }
      } catch (e) {
        console.error("Direct SEO fetch failed:", e);
      }
    };

    loadSeo();
  }, []);

  // const seoData = useSeo(fetchInternationalPatientPageSeo);

  const [formData, setFormData] = useState({
    full_name: "",
    phone: "",
    countryCode: "+91",
    email: "",
    message: "",
    agree: false,
    file: null,
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : type === "file" ? files[0] : value,
    });
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      setFormData((prev) => ({
        ...prev,
        file: e.target.files[0], // Store the selected file
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    const countryCodeRegex = /^\+?\d+$/;

    if (!formData.full_name || !formData.phone) {
      toast.error("Please fill all required fields.", { position: "top-right" });
      return;
    }

    if (!formData.agree) {
      toast.error("Please agree to the terms and conditions.", { position: "top-right" });
      return;
    }

    if (!countryCodeRegex.test(formData.countryCode)) {
      toast.error("Country code must contain only numbers and optionally start with '+'.", { position: "top-right" });
      return;
    }

    setLoading(true);

    const formattedPhone = `${formData.countryCode}${formData.phone}`;

    const formBody = new FormData();
    formBody.append("full_name", formData.full_name);
    formBody.append("phone", formattedPhone);
    formBody.append("email", formData.email);
    formBody.append("agree", formData.agree ? "true" : "false");
    formBody.append("customer_query", formData.message);
    if (formData.file) {
      formBody.append("report", formData.file);
    }
    console.log("File to be submitted:", formData.file);

    try {
      const response = await addInternationalPatientContact(formBody);

      if (response.existingApiResponse?.message && !response.crmResponse?.error) {
        toast.success("Form submitted successfully! We will get back to you soon!", { position: "top-right" });

        // Reset form correctly
        setFormData({
          full_name: "",
          countryCode: "+91",
          phone: "",
          email: "",
          message: "",
          agree: false,
          file: null,
        });
      } else {
        toast.error("Form submission failed. Please try again.");
      }
    } catch (error) {
      toast.error("Error submitting form. Please try again.", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

  // fetch guideline
  useEffect(() => {
    const fetchData = async () => {
      const guidelinesResponse = await fetchInternationalGuidelines();
      if (guidelinesResponse && guidelinesResponse.data) {
        setGuidelines(guidelinesResponse.data);

        setSelectedTab(guidelinesResponse.data[0].id);

        fetchChecklistContent(guidelinesResponse.data[0].id);
      }
    };

    fetchData();
  }, []);

  const fetchChecklistContent = async (id) => {
    try {
      const response = await fetchGuidelinesChecklistPaymentAdvisory(id);

      if (response && response.data) {
        setChecklistContent(response.data);
      }
    } catch (error) {
      console.error("Error fetching checklist content:", error);
    }
  };

  const handleTabClick = (tabId) => {
    setSelectedTab(tabId);
    fetchChecklistContent(tabId);
  };

  //   fetch statistic
  useEffect(() => {
    const fetchStatisticsData = async () => {
      const response = await fetchInternationalStatics();
      if (response && response.data) {
        setStatisticsData(response.data);
      }
    };

    fetchStatisticsData();
  }, []);

  //   fetch the why choose us
  useEffect(() => {
    const fetchReasons = async () => {
      const response = await fetchInternationalWhychooseus();
      if (response && response.data) {
        setReasonsData(response.data);
      }
    };

    fetchReasons();
  }, []);

  // fetch service
  useEffect(() => {
    const fetchServices = async () => {
      const response = await fetchOurServicesCategoryList();
      if (response && response.data) {
        setServicesData(response.data);
        if (response.data.length > 0) {
          setActiveTab(response.data[0].id);
        }
      }
    };

    fetchServices();
  }, []);

  // Fetch details when activeTab change
  useEffect(() => {
    const fetchDetails = async () => {
      if (!activeTab) return;
      const response = await fetchOurServicesCategoryDetails(activeTab);

      if (response && response.data) {
        const transformedData = [
          {
            id: activeTab,
            items: response.data.map((item) => ({
              img_path: item.img_icon,
              text: item.heading,
            })),
          },
        ];
        setCategoryDetails(transformedData);
      }
    };
    fetchDetails();
  }, [activeTab]);

  // fetch spectrum specialites
  useEffect(() => {
    const fetchSpecialities = async () => {
      const response = await fetchSpecialties();

      if (response && response.data) {
        setSpecialitiesData(response.data);
      }
    };

    fetchSpecialities();
  }, []);

  function insertLineBreak(text, wordPosition = 2) {
    const words = text.split(" ");
    if (words.length <= wordPosition) return text;

    return (
      <>
        {words.slice(0, wordPosition).join(" ")}
        <br />
        {words.slice(wordPosition).join(" ")}
      </>
    );
  }

  // Fetch Our Doctor
  useEffect(() => {
    const fetchExprtDoctors = async () => {
      const response = await fetchDoctors();

      if (response && response.data) {
        setDoctors(response.data);
      }
    };
    fetchExprtDoctors();
  }, []);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        // Fetch Banner
        const bannerResponse = await fetchInternationalPatientBanner();
        if (bannerResponse && bannerResponse.data) {
          setBannerData(bannerResponse.data);
        }

        // Fetch Patient Testimonials
        const patientStoryResponse = await fetchPatientStoryVideos();
        if (patientStoryResponse && patientStoryResponse.data) {
          setPatientStories(patientStoryResponse.data);
        }

        // Fetch FAQ data
        const faqResponse = await fetchFAQ(id);
        if (faqResponse && faqResponse.data) {
          setFaq(faqResponse.data);
        }

        // Fetch Get In Touch Section Data
        const healthcareResponse = await fetchInternationalHealthcareList();
        if (healthcareResponse && healthcareResponse.data) {
          setHealthcareData(healthcareResponse.data);
        }

        // Fetch Insurance Partners
        const insuranceResponse = await fetchInsurancePartnerList();

        if (insuranceResponse && insuranceResponse.data) {
          setInsurancePartners(insuranceResponse.data);
        }
      } catch (error) {
        console.error("Error fetching details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [id]);

  // Fetch International Guidelines
  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const guidelinesResponse = await fetchInternationalGuidelines();

        if (guidelinesResponse && guidelinesResponse.data) {
          const guidelinesData = guidelinesResponse.data;
          setGuidelines(guidelinesData);
        }
      } catch (error) {
        console.error("Error fetching guidelines:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, []);

  // const services = [
  //   {
  //     id: "prearrivalpill",
  //     title: "Pre-Arrival Assistance",
  //     items: [
  //       { img: oursic1, text: "Tele-consultation with doctor" },
  //       { img: oursic2, text: "Visa assistance & invitation letter" },
  //       { img: oursic3, text: "Cost estimation for treatment" }
  //     ]
  //   },
  //   {
  //     id: "arstaypill",
  //     title: "Arrival & Stay Assistance",
  //     items: [
  //       { img: oursic4, text: "Airport pickup & drop services" },
  //       { img: oursic5, text: "Accommodation arrangements" },
  //       { img: oursic6, text: "Local transport assistance" }
  //     ]
  //   },
  //   {
  //     id: "medipill",
  //     title: "Medical Treatment & Recovery",
  //     items: [
  //       { img: oursic7, text: "Personalized treatment plans" },
  //       { img: oursic8, text: "24/7 medical assistance" },
  //       { img: oursic9, text: "Post-treatment follow-up" }
  //     ]
  //   },
  //   {
  //     id: "addsupportpills",
  //     title: "Additional Support",
  //     items: [
  //       { img: oursic10, text: "Language interpretation services" },
  //       { img: oursic11, text: "Assistance with medical visa extension" },
  //       { img: oursic12, text: "Local sightseeing and cultural tours" }
  //     ]
  //   }
  // ];

  const handleOpenVideo = (url) => {
    setVideoUrl(url);
    setShowVideoModal(true);
  };
  const handleCloseVideo = () => {
    setShowVideoModal(false);
    setVideoUrl(null);

    document.body.classList.remove("modal-open");

    const modalBackdrops = document.getElementsByClassName("modal-backdrop");
    while (modalBackdrops.length > 0) {
      modalBackdrops[0].parentNode.removeChild(modalBackdrops[0]);
    }
  };

  const renderStyledText = (text) => {
    return text.split(" ").map((word, index) => {
      // Apply green color to 'Healthcare' and 'Patients' only
      if (
        word.toLowerCase() === "healthcare" ||
        word.toLowerCase() === "patients"
      ) {
        return (
          <span key={index} style={{ color: "#0CA854" }}>
            {word}{" "}
          </span>
        );
      }
      // Default color for other words
      return (
        <span key={index} style={{ color: "#2B2B2B", fontWeight: "400" }}>
          {word}{" "}
        </span>
      );
    });
  };

  return (
    <>
      {/* Seo Tags */}
      {/* {seoData && <SeoHelmet seoData={seoData} />} */}
      {seoData && (
        <Helmet>
          <title>{seoData.seo_title}</title>
          <meta name="title" content={seoData.meta_title} />
          <meta name="description" content={stripHtmlForMeta(seoData.meta_description)} />
          <meta name="keywords" content={seoData.meta_keywords} />

          <meta property="og:title" content={seoData.og_title} />
          <meta property="og:description" content={stripHtmlForMeta(seoData.og_description)} />
          <meta property="og:type" content={seoData.og_type} />
          <meta property="og:url" content={seoData.og_url} />
          <meta property="og:image" content={`${baseImage_path}/${seoData.og_image}`} />
          <meta property="og:locale" content={seoData.og_locale} />
          <meta property="og:site_name" content={seoData.og_site_name} />
          <meta property="article:modified_time" content={seoData.article_modified_time} />

          <meta name="twitter:card" content={seoData.twitter_card} />
          <meta name="twitter:title" content={seoData.twitter_title} />
          <meta name="twitter:description" content={stripHtmlForMeta(seoData.twitter_description)} />
          <meta name="twitter:image" content={`${baseImage_path}/${seoData.twitter_image}`} />
          <meta name="twitter:site" content={seoData.twitter_site} />

          <link rel="canonical" href={seoData.canonical_link} />

          {/* Custom scripts injection */}
          {seoData.custom_scripts && (
            <script type="text/javascript" dangerouslySetInnerHTML={{ __html: seoData.custom_scripts }} />
          )}
        </Helmet>
      )}

      {/* <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}
      <Toaster position="top-right" />
      {/* Banner Section */}
      <section className="banner-spac">
        <div className="cust-container">
          <div className="banner-box">
            {bannerData && bannerData.img_path ? (
              <img
                src={`${baseImage_path}${bannerData.img_path.replace(".", "")}`}
                alt={
                  bannerData.banner_heading ||
                  "Healthcare Services for International Patients"
                }
              />
            ) : (
              <img
                src={bannerImage}
                alt="Healthcare Services for International Patients"
              />
            )}
            <div className="ban-con">
              <h1>
                {bannerData[0]?.banner_heading ||
                  "Healthcare Services for International Patients"}
              </h1>
            </div>
          </div>
        </div>
      </section>

      {/* Key statistics dynamic */}
      <section className="international-pat-sec mrgntop70">
        <div className="cust-container">
          <div className="international-pat-sec-inner">
            <div className="row justify-content-center">
              {statisticsData.map((item, index) => (
                <div
                  className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-4 mb-4"
                  key={index}
                >
                  <div className="international-pat-item bglightgreen">
                    <div className="interpat-img">
                      <img
                        src={`${baseImage_path}${item.img_icon}`}
                        alt={item.title}
                      />
                    </div>
                    <div className="interpat-desc">
                      <h5>{item.content}</h5>
                      <p>{item.title}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Get In Touch Section */}
      <section className="contact-form-sec international-pat-form-sec">
        <div className="cust-container">
          <div className="row">
            <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12 mb-4">
              {healthcareData ? (
                <>
                  <div className="international-pat-form-sec-img">
                    <img
                      src={`${baseImage_path}${healthcareData.img_path}`}
                      alt="Healthcare Destination"
                      style={{ width: "100%", height: "auto" }}
                    />
                  </div>
                  <div className="finnest host-det mobtopmarg careerjoininner">
                    <h4>
                      {healthcareData.heading.split("\n").map((line, index) => (
                        <span key={index}>
                          {renderStyledText(line)}
                          <br />
                        </span>
                      ))}
                    </h4>
                    {/* <p>{healthcareData.content}</p> */}
                    <div className="ck-content" dangerouslySetInnerHTML={{ __html: healthcareData.content }} />
                  </div>
                </>
              ) : (
                <p>Loading healthcare information...</p>
              )}
            </div>
            {/* <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 mb-4">
              <div className="right-touch" id="getintouch-form">
                <h3>Get In Touch</h3>
                <p>
                  * Your contact information will remain strictly confidential
                  and will not be published or shared. Required fields are
                  marked.
                </p>
                <div className="cot-frm interp-form">
                  <form onSubmit={handleSubmit}>
                    <div className="form-holder">
                      <label htmlFor="full_name">Name*</label>
                      <input
                        type="text"
                        id="name"
                        name="full_name"
                        placeholder="Please enter name"
                        required
                        value={formData.full_name}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-holder">
                      <label htmlFor="phone">Phone Number*</label>
                      <div className="form-holder-row">
                        <select
                          name="countryCode"
                          value={formData.countryCode}
                          onChange={handleChange}
                        >
                          <option value="">+1</option>
                          <option value="">+44</option>
                          <option value="">+91</option>
                          <option value="">+302</option>
                        </select>
                        <input
                          type="number"
                          id="phone"
                          name="phone"
                          placeholder="Please enter phone number"
                          required
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="form-holder">
                      <label htmlFor="email">Email*</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Please enter your email address"
                        required
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-holder">
                      <label htmlFor="message">Your Message*</label>
                      <textarea
                        id="message"
                        name="message"
                        placeholder="Please write your message here"
                        rows="5"
                        required
                        value={formData.message}
                        onChange={handleChange}
                      ></textarea>
                    </div>

                    <div className="check-box justify-content-between">
                      <div className="tnc-accpt">
                        <input
                          type="checkbox"
                          id="agree"
                          name="agree"
                          required
                          checked={formData.agree}
                          onChange={handleChange}
                        />
                        <label htmlFor="agree">I agree with the terms.</label>
                      </div>
                      <div className="upload-file">
                        <label>Upload Reports (Optional)</label>
                        <input
                          type="file"
                          name="file"
                          onChange={handleFileChange}
                        />
                      </div>
                    </div>

                    <button type="submit" className="btn with-color with-arr">
                      <img src={arrowIcon} alt="Arrow Icon" /> Send Message Now
                    </button>
                  </form>
                  <a href="mailto:intl.marketing@rahejahospital.com">
                    <img src={mailIcon} alt="Email Icon" />
                    intl.marketing@rahejahospital.com
                  </a>
                  <div className="formcallbtn">
                    <a href="tel:+91 98339 06467">
                      <img src={whatsappIcon} alt="WhatsApp Icon" />
                      <img src={callIcon} alt="Call Icon" /> +91 98339 06467
                    </a>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 mb-4">
              <div className="right-touch" id="getintouch-form">
                <h3>Get In Touch</h3>
                <p>
                  * Your contact information will remain strictly confidential and
                  will not be published or shared. Required fields are marked.
                </p>
                <div className="cot-frm interp-form">
                  <form onSubmit={handleSubmit}>
                    <div className="form-holder">
                      <label htmlFor="full_name">Full Name*</label>
                      <input
                        type="text"
                        id="name"
                        name="full_name"
                        placeholder="Please enter full name"
                        required
                        value={formData.full_name}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-holder">
                      <label htmlFor="phone">Phone Number*</label>
                      <div className="form-holder-row">
                        {/* <select
                          name="countryCode"
                          value={formData.countryCode}
                          onChange={handleChange}>
                          <option value="+1">+1</option>
                          <option value="+44">+44</option>
                          <option value="+91">+91</option>
                          <option value="+302">+302</option>
                          </select> */}
                        <input
                          type="text"
                          name="countryCode"
                          value={formData.countryCode}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^(\+)?\d*$/.test(value)) {
                              handleChange(e);
                            }
                          }}
                          style={{ width: "80px", marginRight: "10px" }}
                          placeholder="+1"
                          required
                        />
                        <input
                          type="number"
                          id="phone"
                          name="phone"
                          placeholder="Please enter phone number"
                          required
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="form-holder">
                      <label htmlFor="email">Email</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Please enter your email address"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-holder">
                      <label htmlFor="message">Your Message</label>
                      <textarea
                        id="message"
                        name="message"
                        placeholder="Please write your message here"
                        rows="5"
                        value={formData.message}
                        onChange={handleChange}
                      ></textarea>
                    </div>

                    <div className="check-box justify-content-between">
                      <div className="tnc-accpt">
                        <input
                          type="checkbox"
                          id="agree"
                          name="agree"
                          required
                          checked={formData.agree}
                          onChange={handleChange}
                        />
                        <label htmlFor="agree">I agree with the terms.</label>
                      </div>
                      <div className="upload-file">
                        <label>Upload Reports (Optional)</label>
                        <input
                          type="file"
                          name="file"
                          onChange={handleFileChange}
                        />
                      </div>

                    </div>

                    <button type="submit" className="btn with-color with-arr" disabled={loading}>
                      {loading ? "Sending..." : (
                        <>
                          <img src={arrowIcon} alt="Arrow Icon" /> Send Message Now
                        </>
                      )}
                    </button>

                    {/* <button type="submit" className="btn with-color with-arr">
                                                        <img src={arrowIcon} alt="Arrow Icon" /> Send Message Now
                                                    </button> */}
                  </form>
                  <a href="mailto:intl.marketing@rahejahospital.com">
                    <img src={mailIcon} alt="Email Icon" />
                    intl.marketing@rahejahospital.com
                  </a>
                  <div className="formcallbtn">
                    <a href="tel:+917304509351">
                      <img src={whatsappIcon} alt="WhatsApp Icon" />
                      <img src={callIcon} alt="Call Icon" /> +91 73045 09351
                    </a>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pulse rate image */}
      <section className="pat-hbrange"></section>

      {/* dynamic why choose us  */}
      <section className="fivepointsec card-pblk mrgntop90">
        <div className="cust-container">
          <div className="fivepoint-desc">
            <h2 className="section-title totextleft">Why Choose Us?</h2>
          </div>
          <div className="fivepoint-ip-patient-row">
            {reasonsData.map((reason, index) => (
              <div className="fivepoint-at-item" key={index}>
                <div className="card-end text-center cardend-border">
                  <div className="cardi-img">
                    <img
                      src={`${baseImage_path}${reason.img_icon}`}
                      alt={reason.title}
                    />
                  </div>
                  <div className="cardi-desc">
                    <h3>{reason.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="jdapplybtn" style={{ textAlign: "center" }}>
            <a href="#getintouch-form" className="btn with-color with-arr">
              <img src={arrowIcon} alt="Arrow Icon" />
              Get in Touch Form
            </a>
          </div>
        </div>
      </section>

      {/* our services for international patients dynamic */}
      <section className="international-pat-service-sec mrgntop70 margnbot90">
        <div className="cust-container">
          <div className="finnest host-det mobtopmarg">
            <h2 className="section-title totextleft">
              Our Services for International Patients
            </h2>
          </div>
          <div className="international-pat-service-inner">
            <div className="int-pat-tabs">
              <ul className="nav nav-pills justify-content-center academic-ul intpat-ul">
                {servicesData.map((service) => (
                  <li className="nav-item" key={service.id}>
                    <button
                      className={`nav-link ${activeTab === service.id ? "active" : ""
                        }`}
                      onClick={() => setActiveTab(service.id)}
                    >
                      <span>{service.title}</span>
                    </button>
                  </li>
                ))}
              </ul>
              <div className="tab-content">
                {Array.isArray(categoryDetails) &&
                  categoryDetails.map((service) => (
                    <div
                      key={service.id}
                      className={`tab-pane fade ${activeTab === service.id ? "show active" : ""
                        }`}
                    >
                      <div className="row justify-content-center">
                        {Array.isArray(service.items) &&
                          service.items.map((item, index) => (
                            <div
                              className="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-6 mb-4"
                              key={index}
                            >
                              <div className="inter-pat-service-item">
                                <div className="inter-pat-ser-imgblk">
                                  <div className="inter-pat-ser-img">
                                    <img
                                      src={`${baseImage_path}${item.img_path}`}
                                      alt={item.text}
                                    />
                                  </div>
                                </div>
                                <div className="inter-pat-ser-desc">
                                  <p>{item.text}</p>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="international-pat-service-sec mrgntop70 margnbot90">
        <div className="cust-container">
          <div className="finnest host-det mobtopmarg">
            <h2 className="section-title totextleft">Our Services for International Patients</h2>
          </div>
          <div className="international-pat-service-inner">
            <div className="int-pat-tabs">
              <ul className="nav nav-pills justify-content-center academic-ul intpat-ul">
                {services.map((service) => (
                  <li className="nav-item" key={service.id}>
                    <button
                      className={`nav-link ${activeTab === service.id ? "active" : ""}`}
                      onClick={() => setActiveTab(service.id)}
                    >
                      <span>{service.title}</span>
                    </button>
                  </li>
                ))}
              </ul>
              <div className="tab-content">
                {services.map((service) => (
                  <div
                    key={service.id}
                    className={`tab-pane fade ${activeTab === service.id ? "show active" : ""}`}
                  >
                    <div className="row justify-content-center">
                      {service.items.map((item, index) => (
                        <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-6 mb-4" key={index}>

                          <div className="inter-pat-service-item">
                            <div className="inter-pat-ser-imgblk">
                              <div className="inter-pat-ser-img">
                                <img src={item.img} alt="Service Icon" />
                              </div>
                            </div>
                            <div className="inter-pat-ser-desc">
                              <p>{item.text}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Specialties Section */}
      <section className="section specialties">
        <div className="specail">
          <div className="cust-container">
            <h2 className="section-title">
              Comprehensive Care Across a <span>Spectrum of Specialties</span>
            </h2>
            <div className="spec-card homeSpace">
              {isMobile ? (
                <Swiper
                  spaceBetween={16}
                  slidesPerView={1.1}
                  modules={[Autoplay, Pagination]}
                  autoplay={{ delay: 4000 }}
                  pagination={{ clickable: true }}
                >
                  {specialitiesData.map((spec, idx) => (
                    <SwiperSlide key={idx}>
                      <div className="card-end">
                        <div className="spec-img">
                          <img
                            src={`${baseImage_path}${spec.specialty_icon}`}
                            alt={spec.title}
                          />
                        </div>
                        <h3>{spec.specialty_name}</h3>
                        <p>{spec.specialty_description}</p>

                        <NavLink
                          to={`/specialities/${spec.specialty_name
                            .toLowerCase()
                            .replace(/\s+/g, "-")
                            .replace(/[&]+/g, "and")}`}
                          className="btn with-arr with-arr"
                        >
                          Read More <img src={BlackArrow} alt="" />
                        </NavLink>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                <div className="row">
                  {specialitiesData.map((spec, idx) => (
                    <div
                      className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4"
                      key={idx}
                    >
                      <div className="card-end">
                        <div className="card-end-body">
                          <div className="cardi-img">
                            <img
                              src={`${baseImage_path}${spec.specialty_icon}`}
                              alt={spec.title}
                            />
                          </div>
                          <h3>{spec.specialty_name}</h3>
                          {/* <p>{spec.specialty_description}</p> */}
                          <p dangerouslySetInnerHTML={{ __html: spec.specialty_description }} />
                        </div>
                        <NavLink
                          to={`/specialities/${spec.slug}`}
                          className="btn with-arr"
                        >
                          Read More <img src={BlackArrow} alt="" />
                        </NavLink>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="view-all clrchng">
              <NavLink to="/specialities">View All</NavLink>
            </div>
          </div>
        </div>
      </section>

      {/* Our Doctors Sections */}
      <section className="section expert-doctors">
        <h2 className="section-title">
          <span>Our Expert Doctors</span>
        </h2>
        <div className="cust-container">
          <div className="doctor-box">
            {isMobile ? (
              <Swiper
                modules={[Autoplay]}
                spaceBetween={16}
                slidesPerView={1.1}
                autoplay={{ delay: 2500 }}
                loop={true}
              >
                {doctors.map((doc, index) => (
                  <SwiperSlide key={index}>
                    <div className="oueextpert-cardiolo-item">
                      <div className="cardiolo-item-img">
                        <img
                          src={`${baseImage_path}${doc.doctor_img}`}
                          alt={doc.name}
                        />
                      </div>
                      <div className="cardiolo-itemdesc">
                        <div className="drs-design">
                          <span>{insertLineBreak(doc.specialty_name, 2)}</span>

                          <NavLink
                            to={`/doctor/${doc.slug}`}
                            style={{ color: "#0ca854" }}
                          >
                            View Profile
                          </NavLink>
                        </div>
                        <div className="drs-title">
                          <h4>{doc.name_prefix} {doc.doctor_name}</h4>
                          <div className="drs-title-shareicn">
                            <img
                              src={VectorIcon}
                              alt="Share Icon"
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        </div>
                        <p>
                          {/* Total Experience - {doc.total_experience} */}
                          Total Experience - {doc.total_experience ? doc.total_experience.replace(/\+/g, '') + '+' : 'N/A'} Years
                        </p>
                        <div className="drs-bookapp-cta common-roundcta">
                          <NavLink
                            to={`/doctor/${doc.slug}`}
                            className="btn without-color btnhv"
                          >
                            Book Appointment
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <div className="row">
                {doctors.map((doc, index) => (
                  <div
                    key={index}
                    className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4"
                  >
                    <div className="oueextpert-cardiolo-item">
                      <div className="cardiolo-item-img">
                        <img
                          src={`${baseImage_path}${doc.doctor_img}`}
                          alt={doc.name}
                        />
                      </div>
                      <div className="cardiolo-itemdesc">
                        <div className="drs-design">
                          <span>{insertLineBreak(doc.specialty_name, 2)}</span>

                          <NavLink
                            to={`/doctor/${doc.slug}`}
                            style={{ color: "#0ca854" }}
                          >
                            View Profile
                          </NavLink>
                        </div>
                        <div className="drs-title">
                          <h4>{doc.name_prefix} {doc.doctor_name}</h4>
                          <div className="drs-title-shareicn">
                            <img
                              src={VectorIcon}
                              alt="Share Icon"
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        </div>
                        <p>
                          Total Experience - {doc.total_experience ? doc.total_experience.replace(/\+/g, '') + '+' : 'N/A'} Years
                        </p>
                        <div className="drs-bookapp-cta common-roundcta">
                          <NavLink
                            to={`/doctor/${doc.slug}`}
                            className="btn without-color btnhv"
                          >
                            Book Appointment
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="view-all">
          <NavLink to="/doctor" className="greentxt">
            View All
          </NavLink>
        </div>
      </section>

      {/* International Insurance Partners */}
      {/* <section className="int-ins-partner mrgntop70 margnbot90">
        <div className="cust-container">
          <div className="finnest host-det mobtopmarg">
            <h2 className="section-title totextleft">
              International Insurance Partners
            </h2>
          </div>

          <div className="interna-partner-imgs">
            <div className="int-part-img">
              <img src={imagefttw} alt="" />
            </div>
            <div className="int-part-img">
              <img src={imageftthre} alt="" />
            </div>
            <div className="int-part-img">
              <img src={imageftfour} alt="" />
            </div>
            <div className="int-part-img">
              <img src={imageftfive} alt="" />
            </div>
            <div className="int-part-img">
              <img src={imageftsix} alt="" />
            </div>
            <div className="int-part-img">
              <img src={imagesxsev} alt="" />
            </div>
            <div className="int-part-img">
              <img src={eurpoe} alt="" />
            </div>
            <div className="int-part-img">
              <img src={imagesxnine} alt="" />
            </div>
            <div className="int-part-img">
              <img src={imagesevothre} alt="" />
            </div>
            <div className="int-part-img">
              <img src={paraheal} alt="" />
            </div>
            <div className="int-part-img">
              <img src={imagesevtwo} alt="" />
            </div>
            <div className="int-part-img">
              <img src={raksha} alt="" />
            </div>
            <div className="int-part-img">
              <img src={cigna} alt="" />
            </div>
            <div className="int-part-img">
              <img src={cmn} alt="" />
            </div>
            <div className="int-part-img">
              <img src={euro} alt="" />
            </div>
            <div className="int-part-img">
              <img src={bupa} alt="" />
            </div>
            <div className="int-part-img">
              <img src={maxbupa} alt="" />
            </div>
            <div className="int-part-img">
              <img src={geoblu} alt="" />
            </div>
            <div className="int-part-img">
              <img src={healthtsixty} alt="" />
            </div>
            <div className="int-part-img">
              <img src={grouphener} alt="" />
            </div>
            <div className="int-part-img">
              <img src={sos} alt="" />
            </div>
            <div className="int-part-img">
              <img src={imageeghttw} alt="" />
            </div>
            <div className="int-part-img">
              <img src={imageeghtthre} alt="" />
            </div>
            <div className="int-part-img">
              <img src={roy} alt="" />
            </div>
            <div className="int-part-img">
              <img src={frsaa} alt="" />
            </div>
          </div>
        </div>
      </section> */}

      {/* International Insurance patients dynamic */}
      {/* <section className="int-ins-partner mrgntop70 margnbot90">
        <div className="cust-container">
          <div className="finnest host-det mobtopmarg">
            <h2 className="section-title totextleft">
              International Insurance Partners
            </h2>
          </div>

          <div className="interna-partner-imgs">
            {insurancePartners.map((item, index) => (
              <div className="int-part-img" key={index}>
                <img src={`${baseImage_path}${item.icon}`} alt={item.name} />
              </div>
            ))}
          </div>
        </div>
      </section> */}
      <section className="int-ins-partner mrgntop70 margnbot90">
        <div className="cust-container">
          <div className="finnest host-det mobtopmarg">
            <h2 className="section-title totextleft">
              International Insurance Partners
            </h2>
          </div>


          <div className="interna-partner-imgs mobile-slider">
            <div className="desktop-hide">
              <Swiper
                spaceBetween={16}
                slidesPerView={2}
                breakpoints={{
                  480: { slidesPerView: 3 },
                  768: { slidesPerView: 4 },
                }}
                loop={true}
                autoplay={{ delay: 3000 }}
              >
                {insurancePartners.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="int-part-img">
                      <img
                        src={`${baseImage_path}${item.icon}`}
                        alt={item.name}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>

          <div className="interna-partner-imgs desktop-grid">
            {insurancePartners.map((item, index) => (
              <div className="int-part-img" key={index}>
                <img src={`${baseImage_path}${item.icon}`} alt={item.name} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Guidelines for checklist */}
      <section className="international-pat-service-sec mrgntop70 margnbot90">
        <div className="cust-container">
          <div className="finnest host-det mobtopmarg">
            <h2 className="section-title totextleft">
              Guidelines for Checklist & Payment Advisory
            </h2>
          </div>
          <div className="international-pat-service-inner">
            <div className="int-pat-tabs">
              <ul className="nav nav-pills justify-content-center academic-ul intpat-ul">
                {guidelines.map((tab) => (
                  <li className="nav-item" key={tab.id}>
                    <button
                      className={`nav-link ${selectedTab === tab.id ? "active" : ""
                        }`}
                      onClick={() => handleTabClick(tab.id)}
                    >
                      <span>{tab.title}</span>
                    </button>
                  </li>
                ))}
              </ul>
              <div className="tab-content">
                {checklistContent.length > 0 ? (
                  <div
                    className="tab-pane fade show active"
                    style={{
                      marginBottom: "20px",
                      padding: "20px",
                      border: "2px solid #ddd",
                      borderRadius: "5px",
                    }}
                  >
                    {checklistContent.map((item) => (
                      <div
                        key={item.id}
                        className="content-item"
                        style={{
                          marginBottom: "10px",
                        }}
                      >
                        <strong>{item.content_sub_heading}</strong> –{" "}
                        {/* {item.content} */}
                        <span
                          dangerouslySetInnerHTML={{ __html: item.content }}
                        />
                      </div>
                    ))}
                  </div>
                ) : (
                  <p>No content available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Patient Testimonials */}
      {/* <section className="patient-story-sec mrgntop70 margnbot90" id="patientstoriesid">
                <div className="cust-container">
                    <div className="finnest host-det text-center margin-botom40">
                        <h4>Patient Testimonial</h4>
                    </div>

                    <div className="patient-items">
                        <div className="patei-item patient-col1">
                            <div className="patien-img">
                                <img src={grid1Img} alt="" />
                                <div className="patien-vdoplaybtn">
                                    <button onClick={() => handleOpenVideo("https://www.youtube.com/embed/3ql1yXsvavU")}
                                        data-toggle="modal" data-target="#patientvdo"><img src={videoPlaybtn} alt="" /></button>
                                </div>
                                <div className="patien-desc">
                                    <h4>Mauritian Patient Treated For Esophageal Cancer</h4>
                                    <span>Mr Fazl Hosany</span>
                                </div>
                            </div>

                        </div>
                        <div className="patei-item patient-col2">
                            <div className="patient-col-inner">
                                <div className="patien-img">
                                    <img src={grid2Img} alt="" />
                                    <div className="patien-vdoplaybtn">
                                        <button onClick={() => handleOpenVideo("https://www.youtube.com/embed/3ql1yXsvavU")}
                                            data-toggle="modal" data-target="#patientvdo"><img src={videoPlaybtn} alt="" /></button>
                                    </div>
                                    <div className="patien-desc">
                                        <h4>Neurosurgical Treatment</h4>
                                        <span>Mr Fazl Hosany</span>
                                    </div>
                                </div>

                            </div>
                            <div className="patient-col-inner">
                                <div className="patien-img">
                                    <img src={grid3Img} alt="" />
                                    <div className="patien-vdoplaybtn">
                                        <button onClick={() => handleOpenVideo("https://www.youtube.com/embed/3ql1yXsvavU")}
                                            data-toggle="modal" data-target="#patientvdo"><img src={videoPlaybtn} alt="" /></button>
                                    </div>
                                    <div className="patien-desc">
                                        <h4>Bone Marrow Transplant</h4>
                                        <span>Mr Fazl Hosany</span>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div className="patei-item patient-col3">
                            <div className="patien-img">
                                <img src={grid4Img} alt="" />
                                <div className="patien-vdoplaybtn">
                                    <button onClick={() => handleOpenVideo("https://www.youtube.com/embed/3ql1yXsvavU")}
                                        data-toggle="modal" data-target="#patientvdo"><img src={videoPlaybtn} alt="" /></button>
                                </div>
                                <div className="patien-desc">
                                    <h4>Pre-term Babies</h4>
                                    <span>Ms Sakshi</span>
                                </div>
                            </div>

                        </div>
                        <div className="patei-item patient-col2">
                            <div className="patient-col-inner">
                                <div className="patien-img">
                                    <img src={grid2Img} alt="" />
                                    <div className="patien-vdoplaybtn">
                                        <button onClick={() => handleOpenVideo("https://www.youtube.com/embed/3ql1yXsvavU")}
                                            data-toggle="modal" data-target="#patientvdo"><img src={videoPlaybtn} alt="" /></button>
                                    </div>
                                    <div className="patien-desc">
                                        <h4>Neurosurgical Treatment</h4>
                                        <span>Mr Fazl Hosany</span>
                                    </div>
                                </div>

                            </div>
                            <div className="patient-col-inner">
                                <div className="patien-img">
                                    <img src={grid3Img} alt="" />
                                    <div className="patien-vdoplaybtn">
                                        <button onClick={() => handleOpenVideo("https://www.youtube.com/embed/3ql1yXsvavU")}
                                            data-toggle="modal" data-target="#patientvdo"><img src={videoPlaybtn} alt="" /></button>
                                    </div>
                                    <div className="patien-desc">
                                        <h4>Bone Marrow Transplant</h4>
                                        <span>Mr Fazl Hosany</span>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div className="patei-item patient-col1">
                            <div className="patien-img">
                                <img src={grid1Img} alt="" />
                                <div className="patien-vdoplaybtn">
                                    <button onClick={() => handleOpenVideo("https://www.youtube.com/embed/3ql1yXsvavU")}
                                        data-toggle="modal" data-target="#patientvdo"><img src={videoPlaybtn} alt="" /></button>
                                </div>
                                <div className="patien-desc">
                                    <h4>Mauritian Patient Treated For Esophageal Cancer</h4>
                                    <span>Mr Fazl Hosany</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section> */}
      {/* Expert Insights */}
      <section
        className="patient-story-sec mrgntop70 margnbot90"
        id="patientstoriesid"
      >
        <div className="cust-container">
          <div className="finnest host-det text-center margin-botom40">
            <h4>Patient Testimonial</h4>
          </div>
          <VideoTestimonials />

          {/* <div className="DocVideo-stories">
                        <Swiper
                            className="patvdo-slider"
                            modules={[Autoplay, Navigation, Pagination]}
                            loop={true}
                            spaceBetween={5}
                            slidesPerView={6}
                            grabCursor={false}
                            freeMode={false}
                            mousewheel={false}
                            keyboard={{ enabled: true }}
                            // autoplay={{ delay: 30000 }}
                            // pagination={{ clickable: true, el: ".swiper-pagination1" }}
                            autoplay={showSwiperControls ? { delay: 300000 } : false}
                            pagination={showSwiperControls ? { clickable: true, el: ".swiper-pagination1" } : false}
                            breakpoints={{
                                640: { slidesPerView: 1 },
                                768: { slidesPerView: 1 },
                                1024: { slidesPerView: 6 },
                            }}
                            navigation={showSwiperControls ? {
                                nextEl: ".swiper-cust1-next",
                                prevEl: ".swiper-cust1-prev",
                            } : false}
                        >
                            {patientStories.map((story, index) => {
                                // Extract YouTube Video ID
                                const videoIdMatch = story.video_link.match(/(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
                                const videoId = videoIdMatch ? videoIdMatch[1] : null;

                                // Determine thumbnail URL
                                const thumbnailUrl = story.blog_img
                                    ? `${baseImage_path}/${story.blog_img.replace(/^\.\/?/, "")}`
                                    : videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : grid1Img; // Use grid1Img as fallback

                                // Render two videos in a column if index is a multiple of 3
                                if (index % 3 === 2 && index + 1 < patientStories.length) {
                                    return (
                                        <SwiperSlide key={story.id} className="patient-col2">
                                            <div className="patient-col-inner">
                                                {patientStories.slice(index, index + 2).map((v) => {
                                                    const videoIdInner = v.video_link.match(/(?:youtube\.com\/.*v=|youtu\.be\/)([^&]+)/)?.[1];
                                                    const thumbnailUrlInner = v.blog_img
                                                        ? `${baseImage_path}/${v.blog_img.replace(/^\.\/?/, "")}`
                                                        : videoIdInner ? `https://img.youtube.com/vi/${videoIdInner}/hqdefault.jpg` : grid2Img;

                                                    return (
                                                        <div key={v.id} className="patien-img">
                                                            <img src={thumbnailUrlInner} alt={v.name || "Patient Video"} />
                                                            <div className="patien-vdoplaybtn">
                                                                {videoIdInner && (
                                                                    <button onClick={() => handleOpenVideo(`https://www.youtube.com/embed/${videoIdInner}`)}>
                                                                        <img src={videoPlaybtn} alt="Play Button" />
                                                                    </button>
                                                                )}
                                                            </div>
                                                            <div className="patien-desc">
                                                                <h4>{v.heading || "Patient Story"}</h4>
                                                                <span>{v.name || "Unknown"}</span>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </SwiperSlide>
                                    );
                                }

                                // Render single videos
                                return (
                                    <SwiperSlide key={story.id} className={index % 3 === 0 ? "patient-col1" : "patient-col3"}>
                                        <div className="fullPateint-item">
                                            <div className="patien-img">
                                                <img src={thumbnailUrl} alt={story.name || "Patient Story"} />
                                                <div className="patien-vdoplaybtn">
                                                    {videoId && (
                                                        <button onClick={() => handleOpenVideo(`https://www.youtube.com/embed/${videoId}`)}>
                                                            <img src={videoPlaybtn} alt="Play Button" />
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="patien-desc">
                                                    <h4>{story.heading || "Patient Story"}</h4>
                                                    <span>{story.name || "Unknown"}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>

                        {showSwiperControls && (
                            <div className="videostory-cta" style={{ cursor: "pointer" }}>
                                <span className="swiper-cust1-prev"> &lt; </span>
                                <div className="vdostory-naviga">
                                    <span className="swiper-pagination1"></span>
                                </div>
                                <span className="swiper-cust1-next"> &gt; </span>
                            </div>
                        )}
                    </div> */}
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-sec margnbot90" id="faqid">
        <div className="cust-container">
          <div className="finnest host-det text-center margin-botom40">
            <h4>FAQ</h4>
          </div>
          <div className="faqsec-inner">
            <div className="accordion w-100" id="special-detail-faqs">
              {faq.length > 0 ? (
                faq.map((item, index) => (
                  <div className="card" key={item.id}>
                    <div className="card-header" id={`heading${item.id}`}>
                      <button
                        className="collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target={`#collapse${item.id}`}
                        aria-expanded="false"
                        aria-controls={`collapse${item.id}`}
                      >
                        {item.question}
                      </button>
                    </div>
                    <div
                      id={`collapse${item.id}`}
                      className="collapse"
                      aria-labelledby={`heading${item.id}`}
                      data-parent="#special-detail-faqs"
                    >
                      <div className="card-body">
                        {/* <p>{item.answer}</p> */}
                        <p dangerouslySetInnerHTML={{ __html: item.answer }} />
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No FAQs available for this specialty.</p>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Modal for patient video */}
      {showVideoModal && (
        <div
          className="modal fade custmodal-width show"
          style={{ display: "block" }}
          id="patientvdo"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modalclosebtn">
                <button
                  type="button"
                  className="close"
                  onClick={handleCloseVideo}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                {videoUrl && (
                  <iframe
                    src={videoUrl}
                    title="Video Player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InternationalPatients;
